import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Container, ThemeProvider, createTheme } from "@mui/material";
import ChildComp from "./ChildComp/ChildComp";
import "./App.css";
import {
  fetchListOfCalendarsByWidget,
  updateBookingStatus,
} from "./Services/Organisation.service";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import useGoogleAnalytics from "./hooks/useGoogleAnalytics";
import ModalComponent from "./Components/Modal";
import ActivityCard from "./Components/ActvityCard";
import useOrganisationData from "./hooks/useOrganisationData";
import { groupByCategory, arrayBufferToBase64 } from "./utils";
import CheckoutSuccess from "./Checkout/CheckoutSuccess";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const App: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [activityModalOpen, setActivityModalOpen] = useState(false);
  const [selectedCalendar, setSelectedCalendar] = useState<any>(null);
  const [organisationid, setOrganizationid] = useState("071BDED1-A3FA-4E08-A2AC-BE7A7FBE9D4E");
  const { calendars, widgets, fetchCalendars, setCalendars, setLoading, loading } = useOrganisationData(organisationid, open);
  const [isLive, setIsLive] = useState(false)
  const [isBookingSuccessFullyDone, setIsBookingSuccessfullyDone] = useState(false)
  const { t } = useTranslation();
  const handleOpen = () => setOpen(true);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const handleClose = () => {
    setOpen(false);
    fetchCalendars();
    localStorage.removeItem("organizationid");
    localStorage.removeItem("selectedCategory")
    setSelectedCategory(null);
    setSelectedCalendar(null);
    setActivityModalOpen(false);
    window.parent.postMessage({ action: "closeModal" }, "*");
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(window.location.search);
    const shouldOpenModal = params.get("openModal");
    const shouldContainsWidget = params.get("widgetid");
    const shouldContainsBookingId = params.get("bookingId");
    const shouldContainsPaymentIntentId = params.get("paymentIntentId")
    const isLiveparam = params.get("live")

    if (isLiveparam) {
      setIsLive(true)
    }
    if (shouldContainsBookingId && shouldContainsBookingId !== "" && shouldContainsPaymentIntentId && shouldContainsPaymentIntentId !== "") {
      updateBookingStatus({ bookingsalutation: "success", paymentIntentId: shouldContainsPaymentIntentId }, shouldContainsBookingId, isLive)
      setIsBookingSuccessfullyDone(true)
      params.delete("bookingId");
      params.delete("paymentIntentId");
      params.delete("payment_intent");
      params.delete("payment_intent_client_secret");
      // Set the URL back without the bookingId parameter
      window.history.replaceState({}, '', `${url.pathname}?${params}`);
    }
    if (shouldOpenModal === "true") {
      setOrganizationid(params.get("organizationid") as string);
      if (shouldContainsWidget && shouldContainsWidget !== "" && shouldOpenModal === "true") {
        setTimeout(() => {
          fetchListOfCalendarsFromWidget(shouldContainsWidget);
        }, 500)
      }
    }

  }, []);

  const fetchListOfCalendarsFromWidget = async (id: string) => {
    try {
      setLoading(true)
      const data = await fetchListOfCalendarsByWidget(id);
      if (data.data) {
        setCalendars(data.data);
        setOpen(true);
        setLoading(false)
      }
    } catch (error) {
      console.log(error);
    }
  };
  const calendarsByCategory = groupByCategory(calendars);
  const hasCategories = Object.keys(calendarsByCategory).length > 1 || Object.keys(calendarsByCategory)[0] !== 'Uncategorized';


  useEffect(() => {
  if (selectedCategory && calendarsByCategory[selectedCategory]?.length === 1) {
    const activity = calendarsByCategory[selectedCategory][0];
    setActivityModalOpen(true);
    setSelectedCalendar({
      ...activity,
      category: selectedCategory,
      imageUrl: activity?.image ? arrayBufferToBase64(activity.image) : "https://www.filepicker.io/api/file/Ofk2FoClQtOxtacCjMOY",
    });
  }
}, [selectedCategory, calendarsByCategory]);

useEffect(() => {
  if (!selectedCategory && !hasCategories && calendarsByCategory['Uncategorized']?.length === 1) {
    const activity = calendarsByCategory['Uncategorized'][0];
    setActivityModalOpen(true);
    setSelectedCalendar({
      ...activity,
      category: 'Uncategorized',
      imageUrl: activity?.image ? arrayBufferToBase64(activity.image) : "https://www.filepicker.io/api/file/Ofk2FoClQtOxtacCjMOY",
    });
  }
}, [selectedCategory, hasCategories, calendarsByCategory]);
 const renderCalendars = (category: any) => {
  // If there's only one activity, auto-open it immediately and show a loading state
  if (calendarsByCategory[category]?.length === 1) {
    const activity = calendarsByCategory[category][0];
    
    // Use setTimeout to avoid state update during render
    if (!activityModalOpen) {
      setTimeout(() => {
        setActivityModalOpen(true);
        setSelectedCalendar({
          ...activity,
          category: category,
          imageUrl: activity?.image ? arrayBufferToBase64(activity.image) : "https://www.filepicker.io/api/file/Ofk2FoClQtOxtacCjMOY",
        });
      }, 0);
    }
    
    // Return the ChildComp directly since there's only one option
    return activityModalOpen && selectedCalendar?.calendarname === activity.calendarname ? (
      <ChildComp
        setActivityModalOpen={setActivityModalOpen}
        activityModalOpen={activityModalOpen}
        organisationid={organisationid}
        buttonText={t("BookNow")}
        title={activity.calendarname}
        calendarObject={selectedCalendar}
        isLive={isLive}
      />
    ) : (
      <div>Loading...</div>
    );
  }

  // Only render tiles when there are multiple options
  return calendarsByCategory[category]?.map((activity: any, index: number) => (
    <ActivityCard
      key={`${activity.calendarname}-${index}`}
      imageUrl={activity?.image ? arrayBufferToBase64(activity.image) : "https://www.filepicker.io/api/file/Ofk2FoClQtOxtacCjMOY"}
      activityCardKey={activity.calendarname}
      title={activity.calendarname}
      onClick={() => {
        setActivityModalOpen(true); 
        setSelectedCalendar({
          ...activity,
          category: category,
          imageUrl: activity?.image ? arrayBufferToBase64(activity.image) : "https://www.filepicker.io/api/file/Ofk2FoClQtOxtacCjMOY",
        })
      }}
    >
      {
        activityModalOpen && selectedCalendar?.calendarname === activity.calendarname &&
        <ChildComp
          setActivityModalOpen={setActivityModalOpen}
          activityModalOpen={activityModalOpen}
          organisationid={organisationid}
          buttonText={t("BookNow")}
          title={activity.calendarname}
          calendarObject={selectedCalendar}
          isLive={isLive}
        />
      }
    </ActivityCard>
  ));
};

  const categoryMapper: any = {
    'resident': 'Residents',
    'nonresident': 'Tourists'
  }
  useGoogleAnalytics(process.env.REACT_APP_GTA_ID as string);

  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${process.env.REACT_APP_GTA_ID}');`;

    const bodyScript = document.createElement('noscript');
    bodyScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GTA_ID}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    document.head.appendChild(script);
    document.body.appendChild(bodyScript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(bodyScript);
    };
  }, [])

  useEffect(() => {
    if (open && !selectedCategory && hasCategories && Object.keys(calendarsByCategory)?.length === 1) {
      setSelectedCategory(Object.keys(calendarsByCategory)[0]);
      localStorage.setItem("selectedCategory", Object.keys(calendarsByCategory)[0])
    }
  }, [selectedCategory, hasCategories, open])
  return (
    <ThemeProvider theme={theme}>
      <div >
        {/* <LanguageSwitcher /> */}
        <Container maxWidth="sm" style={{ marginTop: "2rem" }}>
          <Button variant="contained" color="primary" onClick={handleOpen}>
            {t("OpenModel")}
          </Button>
          {
            open &&
            <ModalComponent open={open} closeModal={handleClose} backgroundcolor={calendars[0]?.backgroundcolor} title={calendars[0]?.modaldescription ? calendars[0]?.modaldescription : t("DolphinAcademy")}>

              <div style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: "1rem",
              }}>

                {!selectedCategory && hasCategories ? (
                  Object.keys(calendarsByCategory).map(category => (
                    <ActivityCard key={category} imageUrl={category === "nonresident" ? 'https://www.filepicker.io/api/file/IkA2DdjQZqFCr2A7HFhr' : 'https://www.filepicker.io/api/file/XgYe9ZU8TYGJ3NNa9HNA'} title={category === "nonresident" ? 'Curacao Sea Aquarium' : 'Residents of Curacao only'} onClick={() => { setSelectedCategory(category); localStorage.setItem("selectedCategory", category) }} buttonText={categoryMapper[category]}>

                    </ActivityCard>
                  ))
                ) : !loading && (
                  renderCalendars('Uncategorized')
                )}
                {selectedCategory && !loading && renderCalendars(selectedCategory)}
                {
                  loading && <CircularProgress />
                }
              </div>
            </ModalComponent>
          }
        </Container>
        <hr />
        <h2>Widgets Activity</h2>
        <Container maxWidth="sm" style={{ marginTop: "2rem", gap: "1rem", display: "flex" }}>
          {widgets?.length > 0 &&
            widgets.map((widget: any) => {
              return (
                <Button
                  key={widget.modalid}
                  variant="contained"
                  color="primary"
                  onClick={() => fetchListOfCalendarsFromWidget(widget?.modalid)}
                >
                  {widget.buttonname}
                </Button>
              );
            })}
        </Container>
        {
          isBookingSuccessFullyDone && <ModalComponent open={isBookingSuccessFullyDone} closeModal={() => setIsBookingSuccessfullyDone(false)} backgroundcolor={"#fff"}>
            <CheckoutSuccess />
          </ModalComponent>
        }
      </div>
    </ThemeProvider >
  );
};

export default App;
